module.exports = __webpack_public_path__ + "static/media/strategy.cffa4e3b.PNG";